import { Box, Flex, Text, Image, Button } from "theme-ui";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { AppPostsExamples } from "src/components/molecules";
import app_icon from "src/assets/images/vec_icon.png";
import android_icon from "src/assets/images/android_icon.png";
import ios_icon from "src/assets/images/ios_icon.png";
import apple_store from "src/assets/images/App_Store.png";
import google_play from "src/assets/images/Google_Store.png";
import copy from "src/content/copy.json";
import { STORES } from "src/constants";
import { extractBaseLang } from "src/utils";
import { RootState } from "src/redux";

const actionsSelector = (lang: string, country?: string) => {
  if (lang === "es" || country === "AR") {
    return (
      <Flex
        sx={{
          justifyContent: "space-between",
          my: 6,
          px: [4, 5, 0],
          flexDirection: ["column", "column", "row"],
          gap: 4,
        }}
      >
        <Button
          onClick={() => window.open(STORES.GOOGLE, "_blank")}
          variant="iconText"
          sx={{ textTransform: "uppercase", justifyContent: "center" }}
        >
          <Image src={android_icon} alt="android" width="26px" my="2px" />
          {copy.btns.play_store}
        </Button>
        <Button
          onClick={() => window.open(STORES.APPLE, "_blank")}
          variant="iconText"
          sx={{ textTransform: "uppercase", justifyContent: "center" }}
        >
          <Image src={ios_icon} alt="ios" width="26px" />
          {copy.btns.app_store}
        </Button>
      </Flex>
    );
  }
  return (
    <Flex
      sx={{ flexDirection: ["column", "row"], alignItems: "center", my: 6 }}
    >
      <Text sx={{ fontSize: "18px" }}>Available soon in</Text>
      <Box>
        <Image width={"120px"} ml={3} src={google_play} alt="google store" />
        <Image width={"120px"} ml={3} src={apple_store} alt="apple store" />
      </Box>
    </Flex>
  );
};

export const HomeBanner = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = extractBaseLang(i18n.language);

  const {
    location: { country },
  } = useSelector((state: RootState) => state.visitor);

  return (
    <>
      <Flex
        sx={{
          JustifyContent: "space-around",
          flexFlow: ["column", "column", "row"],
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            maxWidth: ["100%", "100%", "50%"],
            pr: [null, null, "84px"],
            pt: 5,
          }}
        >
          <Box
            sx={{
              textAlign: ["center", "center", "left"],
            }}
          >
            <Text
              as="h1"
              sx={{
                fontSize: [5, 5, 7],
                fontFamily: "heading",
                fontWeight: 800,
                display: "block",
                lineHeight: "heading",
                mb: [3, 3, 4],
                px: [5, 7, 0],
              }}
            >
              {t("home.title")}
            </Text>
            <Text
              as="p"
              sx={{ fontSize: [2, 3, 5], display: "block", px: [7, 7, 0] }}
            >
              {t("home.text")}
            </Text>
            <Flex
              sx={{
                my: 3,
                flexDirection: ["column", "column", "row"],
                alignItems: "center",
              }}
            >
              <Image
                src={app_icon}
                alt="app icon"
                sx={{ width: "45px", my: [4, 4, 0] }}
              />
              <Text
                as="p"
                sx={{ fontWeight: "bold", fontSize: [4, 4, 5], ml: 4 }}
              >
                {t("home.subTitle")}
              </Text>
            </Flex>
            <Box sx={{ display: ["none", "none", "block"] }}>
              {actionsSelector(currentLanguage, country)}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            maxWidth: ["100%", "100%", "50%"],
            pl: [null, null, "24px"],
            mt: [2, 3, "-40px"],
            textAlign: "center",
          }}
        >
          <AppPostsExamples />
        </Box>
      </Flex>
      <Box sx={{ display: ["block", "block", "none"] }}>
        {actionsSelector(currentLanguage, country)}
      </Box>
    </>
  );
};
